export enum ELyrvEventName {
  LYRV_FLOW_EARNINGS_ESTIMATE_STARTED = 'LYRV Flow Earnings Estimate Started',
  LYRV_FLOW_EARNINGS_ESTIMATE_CALCULATED = 'LYRV Flow Earnings Estimate Calculated',
  LYRV_FLOW_EARNINGS_ESTIMATE_COMPLETED = 'LYRV Flow Earnings Estimate Completed',
  EARNINGS_ESTIMATE_COMPLETED = 'Earnings Estimate Completed',
}

interface ILYRVEvent {
  isOwner: boolean;
  totalPublishedListings: number;
  totalUnpublishedListings: number;
}

export interface ILyrvEstimateStarted extends ILYRVEvent {
  isLoggedIn: boolean;
}

export interface ILyrvEstimateCompleted extends ILYRVEvent {
  vehicleType: string;
}

export interface ILyrvEstimateCalculated extends ILYRVEvent {
  vehicleType: string;
  estimatedEarningsLower: number;
  estimatedEarningUpper: number;
}
export interface IEarningsEstimateCompleted extends ILYRVEvent {
  vehicleType: string;
  estimatedEarningsPerYear: number;
  rentalType: string;
}
